"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVideoAttachmentStyle;

function createVideoAttachmentStyle() {
  return {};
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVWaWRlb0F0dGFjaG1lbnRTdHlsZSJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0eWxlcy9TdHlsZVNldC9WaWRlb0F0dGFjaG1lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlVmlkZW9BdHRhY2htZW50U3R5bGUoKSB7XG4gIHJldHVybiB7fTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLDBCQUFULEdBQXNDO0VBQ25ELE9BQU8sRUFBUDtBQUNEIn0=